

import React, { Component } from 'react';

import cx from 'classnames';
import Draggable from 'react-draggable';
import onEnterPressed from '@shootsta/on-enter-pressed';
import Icon from '../../Icon';
import '../styles/_floatingWindow.scss';

const UPLOADER_BODY_HEIGHT = 270;

















const isHeaderFunction = (header) => typeof header === 'function';

const isValidReactComponent = (jsxElement) => {
  const isFunc = isHeaderFunction(jsxElement);
  return React.isValidElement(isFunc ? jsxElement({ isExpanded: false }) : jsxElement);
};


export default class FloatingWindow extends Component


{
  static defaultProps = {
    drag: true,
    initiallyOpen: false,
    position: 'left'
  };

  constructor(props) {
    super(props);
    const { initiallyOpen = false } = this.props;
    this.state = {
      isExpanded: initiallyOpen
    };
  }

  toggleExpand = () => {
    const { blockExpand, isExpanded } = this.state;

    const { content } = this.props;

    if (!content) return;

    if (blockExpand) {
      return void this.setState({ dragging: false, blockExpand: false });
    }
    this.setState({ dragging: false, isExpanded: !isExpanded });
  };

  renderHeader = () => {
    const { blockExpand, isExpanded } = this.state;
    const { header, toggleIcon } = this.props;

    return (
      <div
        className={cx('expand-drag-container--header', {
          'expand-drag-container--header--collapsed': !isExpanded
        })}
        style={{ cursor: blockExpand ? 'grabbing' : void 0 }}
        role="button"
        tabIndex={0}
        onKeyDown={onEnterPressed({ onClick: this.toggleExpand })}
        onClick={this.toggleExpand}>

        <div className="expand-drag-container--header--content">
          {isHeaderFunction(header) ? header({ isExpanded }) : header}
          <div
            className={cx('expand-drag-container--header--toggle-icon', {
              'expand-drag-container--header--toggle-icon--collapsed': !isExpanded
            })}>

            {toggleIcon ||
            <Icon
              name="arrowup"
              color="white"
              size={8} />}


          </div>
        </div>
      </div>);

  };

  handleDrag = () => {
    const { dragging, blockExpand } = this.state;

    if (dragging && blockExpand) {
      return;
    }

    if (dragging) {
      return void this.setState({ blockExpand: true });
    }

    this.setState({ dragging: true });
  };

  renderItemsList = () => {
    const { content } = this.props;
    const { isExpanded } = this.state;

    const hidden = !isExpanded || !content;

    return (
      <div
        className={cx('expand-drag-container--body', {
          'expand-drag-container--body--hidden': hidden
        })}>

        {content}
      </div>);

  };

  render() {
    const { classNames, drag, header, position } = this.props;
    const { isExpanded } = this.state;

    // WARNING - THIS WILL NOT COMPOSE NICELY WITH OTHER POSSIBLE FUTURE USES
    if (!isValidReactComponent(header)) {
      window.onbeforeunload = null;
      return null;
    }

    // WARNING - THIS WILL NOT COMPOSE NICELY WITH OTHER POSSIBLE FUTURE USES
    window.onbeforeunload = () => true;

    return (
      <>
        <div
          className="expand-drag-container-draggable"
          style={{ paddingTop: isExpanded ? 0 : UPLOADER_BODY_HEIGHT }} />

        <Draggable
          disabled={!drag}
          bounds=".expand-drag-container-draggable"
          onDrag={this.handleDrag}
          handle=".expand-drag-container--header">

          <div
            className={cx('expand-drag-container', classNames, {
              'expand-drag-container--collapsed': !isExpanded,
              'expand-drag-container--position-right': position === 'right'

            })}>

            {this.renderHeader()}
            {this.renderItemsList()}
          </div>
        </Draggable>
      </>);

  }
}